module.exports = __webpack_public_path__ + "static/media/icon_dashboard.4c4af7f3.png";